import { render, staticRenderFns } from "./AmazonLogoutButton.vue?vue&type=template&id=3cfb1865&scoped=true&"
var script = {}
import style0 from "./AmazonLogoutButton.vue?vue&type=style&index=0&id=3cfb1865&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfb1865",
  null
  
)

export default component.exports